'use strict';

var $ = require('jquery'),
    isEmpty = require('../lang/is-empty');

function applyFn(aItem, args, fn) {
    var i;

    for (i = 0; i < aItem.length; i++) {
        fn.apply($(aItem[i]), args);
    }
}

function addClass(aItem, nameClass) {
    applyFn(aItem, [nameClass], $().addClass);
}

function removeClass(aItem, nameClass) {
    applyFn(aItem, [nameClass], $().removeClass);
}

/**
 * Metodo per aggiungere/togliere una classe ricorsivamente a elementi di un array
 *
 * @param aItem Array [ Array di elementi su cui performare l'azione ]
 * @param nameClass string [ Specifica il nome della classe dalla quale performare l'azione ES: 'pointer', 'wait', 'default' ]
 * @param type string Specifica l'azione da eseguire ex: add, remove. Supportate ad ora addClass, removeClass
 */
module.exports = function setClass(aItem, nameClass, type) {
    if (isEmpty(type) || type === 'add') {
        addClass(aItem, nameClass);
    } else if (type === 'remove') {
        removeClass(aItem, nameClass);
    }
};
